var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(!_vm.isNewDesign && _vm.isValidEmployee)?_c('EmployeePathToReadinessView',{on:{"employeeStatusChanged":_vm.handleEmployeeStatusChanged}}):(_vm.isValidEmployee)?_c('NewEmployeePathToReadinessView',{on:{"employeeStatusChanged":_vm.handleEmployeeStatusChanged}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }